import React, { useState } from "react";
import "./feedbackPopup.css";

const FeedbackPopup = ({ isOpen, onClose, onSubmitFeedback }) => {
  const [feedback, setFeedback] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h3>Submit Your Feedback</h3>
        <div className="feedback-reasons">
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Answer is not correct"
              checked={selectedReason === "Answer is not correct"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Great Response !
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Answer needs to be elaborative"
              checked={selectedReason === "Answer needs to be elaborative"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Answer is not correct
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Answer needs to be elaborative"
              checked={selectedReason === "Answer needs to be elaborative"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Answer needs to be elaborative
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Factually incorrect"
              checked={selectedReason === "Factually incorrect"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Factually incorrect
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Missing key information"
              checked={selectedReason === "Missing key information"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Missing key information
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Inappropriate, unsafe, or biased"
              checked={selectedReason === "Inappropriate, unsafe, or biased"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Inappropriate, unsafe, or biased
          </label>
          <label className="feedback-label">
            <input
              type="radio"
              name="feedbackReason"
              value="Other"
              checked={selectedReason === "Other"}
              onChange={(e) => setSelectedReason(e.target.value)}
            />
            Other
          </label>
        </div>
        <textarea
          placeholder="Tell us how to improve..."
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        ></textarea>
        <div className="popup-buttons">
          <button onClick={onClose}>Submit</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPopup;